import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import withScopedTranslations from '../../../withScopedTranslations/withScopedTranslations';

const Label = ({ name, label, optional, t, hasError, labelStyle, children, }) => {
  const styles = useStyles({ labelStyle, });
  const labelClasses = classNames('input-label', { 'input-label-error': hasError, }, styles.label);
  const optionalText = t('optional');
  const renderedLabel = optional ? (
    <span>{label}<span className="optional-field__label">{optionalText}</span></span>
  ) : <span>{label}</span>;


  return (
    <label className={labelClasses} htmlFor={name}>
      {renderedLabel}

      {children}
    </label>
  );
};

Label.propTypes = {
  name: PropTypes.string,
  t: PropTypes.func.isRequired,
  labelStyle: PropTypes.object,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  optional: PropTypes.bool,
  hasError: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
};

Label.defaultProps = {
  label: '',
  labelStyle: {},
  optional: false,
  name: null,
  hasError: false,
  children: '',
};

const useStyles = createUseStyles({
  label: (props) => ({
    fontSize: '15px',
    ...props.labelStyle,
  }),
});


export default withScopedTranslations('inputs')(Label);
